<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-number---IVP sigil_not_in_toc"><span epub:type="pagebreak" id="pagevii" title="vii"></span></h1>
<h1 class="chapter-title---IVP" id="_idParaDest-1"><a id="_idTextAnchor000"></a>Contents</h1>
<div epub:type="toc" id="_idContainer002">
<p class="firstleft"><a href="#/Text/06_foreword#_idTextAnchor001"><i class="i">Foreword by Wesley Hill</i><i class="TOC_page_no"> </i></a><i class="TOC_page_no"></i></p>
<p class="firstleft"><a href="#/Text/07_prelude#_idTextAnchor002"><span class="sans"><b>PRELUDE: PROMISES</b></span></a> <i class="TOC_page_no"> </i></p>
<blockquote>
<p class="left"><b class="TOC_chpt_no"></b> <a href="#/Text/08_ch1#_idTextAnchor003">1 Revelation</a> <i class="TOC_page_no"></i></p>
<p class="first"><b class="TOC_chpt_no"></b> <span href="#/Text/09_ch2#_idTextAnchor004" title="Link target outside of Sample">2 Almost Straight</span><i class="TOC_page_no"> </i></p>
<p class="firstleft"><b class="TOC_chpt_no"></b> <span href="#/Text/10_ch3#_idTextAnchor005" title="Link target outside of Sample">3 Debating the Divine</span> <i class="TOC_page_no"></i></p>
<p class="firstleft"><b class="TOC_chpt_no"></b> <span href="#/Text/11_ch4#_idTextAnchor006" title="Link target outside of Sample">4 What God Called Good</span><i class="TOC_page_no"> </i></p>
</blockquote>
<p class="firstleft"><span href="#/Text/12_interlude#_idTextAnchor007" title="Link target outside of Sample"><b><span class="sans">INTERLUDE: A SONG FOR THE UNKNOWING	</span></b></span><i class="TOC_page_no"></i></p>
<blockquote>
<p class="left"><b class="TOC_chpt_no"></b> <span href="#/Text/13_ch5#_idTextAnchor008" title="Link target outside of Sample">5 Stranger Incognito</span><i class="TOC_page_no"></i></p>
<p class="firstleft"><b class="TOC_chpt_no"></b> <span href="#/Text/14_ch6#_idTextAnchor009" title="Link target outside of Sample">6 To Know as I Am Known</span><i class="TOC_page_no"> </i></p>
<p class="firstleft"><b class="TOC_chpt_no"></b> <span href="#/Text/15_ch7#_idTextAnchor010" title="Link target outside of Sample">7 Nature Abhors a Vacuum</span><i class="TOC_page_no"> </i></p>
<p class="firstleft"><b class="TOC_chpt_no"></b> <span href="#/Text/16_ch8#_idTextAnchor011" title="Link target outside of Sample">8 Quo Vadis?</span> <i class="TOC_page_no"></i></p>
</blockquote>
<p class="firstleft"> <span href="#/Text/17_postlude#_idTextAnchor012" title="Link target outside of Sample"><b><span class="sans">POSTLUDE: A LETTER TO MYSELF AT AGE TWELVE</span> </b></span><i class="TOC_page_no"> </i></p>
<p class="firstleft"><span href="#/Text/18_acknowledgments#_idTextAnchor013" title="Link target outside of Sample"><i class="TOC_page_no">Acknowledgments </i></span></p>
<p class="chapter-number---IVP sigil_not_in_toc"><span epub:type="pagebreak" id="pageviii" title="viii"></span></p>
<p class="firstleft"> <span href="#/Text/19_praise#_idTextAnchor014" title="Link target outside of Sample"><i class="i">Praise for </i>Single, Gay, Christian</span> </p>
<p class="firstleft"> <span href="#/Text/20_author#_idTextAnchor015" title="Link target outside of Sample"><i class="i">About the Author</i></span></p>
<p class="firstleft"> <span href="#/Text/21_moreIVP#_idTextAnchor016" title="Link target outside of Sample"><i class="i">More Titles from InterVarsity Press</i></span></p>
<p class="firstleft"> <span href="#/Text/03_copyright" title="Link target outside of Sample"><i class="i">Copyright</i></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?5d3d91e3